import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const modelUrl = process.env.REACT_APP_MODELPATH+"dressingcabinet.glb";

export default function DressingCabinetModel(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(modelUrl);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object436.geometry}
        material={nodes.Object436.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object437.geometry}
        material={nodes.Object437.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object438.geometry}
        material={nodes.Object438.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object439.geometry}
        material={nodes.Object439.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object440.geometry}
        material={nodes.Object440.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object441.geometry}
        material={nodes.Object441.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object431.geometry}
        material={materials["l2furn-cabinet"]}
      />
    </group>
  );
}

useGLTF.preload(modelUrl);